<wiz-vgroup width="100%" height="100%" gap="5" style="padding-bottom: 3px;"> <!--padding bottom pour l'affichage de l'ombre-->
  <wiz-vgroup class="top-section" width="100%">
    <wiz-hgroup
      width="100%"
      verticalAlign="center"
      [horizontalAlign]="'space-between'"
      *ngIf="modes && modes.length > 0"
      class="multi-list-header">
      <ng-content select="[target=header-title]"></ng-content>
      <wiz-hgroup horizontalAlign="end" width="100%" verticalAlign="center">
        <ng-content select="[target=icons]"></ng-content>
        <div *ngIf="modes && modes.length > 1" padding="2px 2px 2px 20px">
          <wiz-hgroup
            horizontalAlign="end"
            width="100%"
            style="font-size: 16px"
            verticalAlign="center"
          >
            <ng-container *ngFor="let mode of modes">
              <wiz-button
                width="20px"
                class="listButton"
                height="24px"
                (click)="changeMode(mode.code)"
                [ngClass]="{ 'selected-mode': currentMode === mode.code }"
                [wizIcon]="mode.icon"
                [wizTooltip]="'$.md.' + mode.code + '.$'"
              >
              </wiz-button>
            </ng-container>
          </wiz-hgroup>
        </div>
      </wiz-hgroup>
    </wiz-hgroup>
    <wiz-hgroup width="100%" class="multi-list-title">
      <ng-content select="[target=title]"></ng-content>
    </wiz-hgroup>
  </wiz-vgroup>
  
  <div #listContainer width="100%" height="100%" class="multi-list-content">
    <ng-container *ngTemplateOutlet="template" width="100%"></ng-container>
  </div>

  <wiz-vgroup class="bottom-section">
    <filter-component #filter *ngIf="hasFilter" minHeight="44px" [width]="filterWidth"></filter-component>
  </wiz-vgroup>
</wiz-vgroup>

<ng-template #listTpl>
  <wiz-list
    width="100%"
    height="100%"
    [wizDataProvider]="datasource"
    [wizItemRenderer]="listConfig.renderer"
    [itemHeight]="listConfig.itemHeight !== 0 ? listConfig.itemHeight : 30"
    [wizLabelField]="listConfig.labelField"
  >
  </wiz-list>
</ng-template>
<ng-template #tilesTpl>
  <wiz-tile-list
    width="100%"
    height="100%"
    [wizDataProvider]="datasource"
    [wizItemRenderer]="tileConfig.renderer"
    [itemHeight]="tileConfig.itemHeight !== 0 ? tileConfig.itemHeight : 100"
    [itemWidth]="tileConfig.itemWidth !== 0 ? tileConfig.itemWidth : 145"
  >
  </wiz-tile-list>
</ng-template>
<ng-template #gridTpl>
  <wiz-ag-grid
    #agGrid
    width="100%"
    height="100%"
    class="ag-theme-alpine"
    [wizDatasource]="datasource"
    [rowClassRules]="gridConfig.rowClassRules"
    [columnDefs]="gridConfig.columns"
    [frameworkComponents]="gridConfig.renderers"
    [suppressRowClickSelection]="shouldSuppressGridClick"
    [wizRowSelection]="gridRowSelection"
  >
  </wiz-ag-grid>
</ng-template>
<ng-template #treeTpl>
  <wiz-tree
    width="100%"
    height="100%"
    [wizDataProvider]="datasource"
    [itemHeight]="treeConfig.itemHeight"
    [wizItemRenderer]="treeConfig.renderer"
    [actionsRenderer]="treeConfig.actionRenderer"
    [wizLabelField]="treeConfig.labelField"
  >
  </wiz-tree>
</ng-template>
